import React from "react";
import { graphql } from "gatsby";
import { FeaturedTrees } from "./FeaturedTrees";
import {
  KontentComponentSettings,
  KontentTreeDetailPage,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatTree } from "../../../lib/useTrees";

interface Props extends KontentComponentSettings {
  subhead: StringValue;
  trees: {
    value: KontentTreeDetailPage[];
  };
}

const FeaturedTreesContainer: React.FC<Props> = ({
  subhead,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
  ...props
}) => {
  const trees = props.trees.value.map((tree) => {
    const treeData = formatTree(tree.elements.content.value[0]);
    const pageInfo = {
      url: tree.elements.url.url,
      title: tree.elements.title.value,
    };

    return {
      page: pageInfo,
      ...treeData,
    };
  });

  return (
    <FeaturedTrees
      trees={trees}
      subhead={subhead?.value}
      id={props.id}
      anchor={component_settings__anchor_name?.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
    ></FeaturedTrees>
  );
};

export default FeaturedTreesContainer;

export const fragmentFeaturedTreesContainer = graphql`
  fragment FeaturedTrees on kontent_item_component___featured_trees {
    elements {
      subhead {
        value
      }
      trees {
        value {
          ... on kontent_item_page {
            elements {
              title {
                value
              }
              url {
                url
              }
              content {
                value {
                  ... on kontent_item_content___tree_detail {
                    id
                    system {
                      type
                      id
                    }
                    elements {
                      content {
                        ...kontentSimpleRichText
                      }
                      hero_image {
                        value {
                          ...kontentMediaImage
                        }
                      }
                      thumbnail_image {
                        value {
                          ...kontentMediaImage
                        }
                      }
                      tree_collection {
                        value {
                          codename
                          name
                        }
                      }
                      tree_id {
                        value
                      }
                      scientific_name {
                        value
                      }
                      common_name {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
